import { render, staticRenderFns } from "./BreadcrumbV2.vue?vue&type=template&id=99f0471a&"
import script from "./BreadcrumbV2.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports